export class CheckoutService {
    constructor(orderInfoService, cartService, basicInfoService, addressService, paymentService, localStorageService, blockingCalloutService,
        featureFlagService, $q, $state, LOCAL_STORAGE) {
        'ngInject';
        this.orderInfoService = orderInfoService;
        this.cartService = cartService;
        this.basicInfoService = basicInfoService;
        this.addressService = addressService;
        this.localStorageService = localStorageService;
        this.paymentService = paymentService;
        this.blockingCalloutService = blockingCalloutService;
        this.featureFlagService = featureFlagService;
        this.$q = $q;
        this.$state = $state;
        this.LOCAL_STORAGE = LOCAL_STORAGE;

        this.data = {
            basicInfo: {},
            payment: {
                tip: 0.0,
                method: this._getPaymentMethod()
            },
            address: {}
        };

        this.cartData = {};
        this.initialize();
    }

    initialize() {
        return this.cartService.getCart()
            .then(() => this.cartData = this.cartService.getCartData());
    }

    /* Address */
    setAddress(address) {
        this.data.address = angular.copy(address);
    }

    clearAddress() {
        this.data.address = {};
    }

    /* Basic Info */
    setBasicInfo(basicInfo) {
        this.data.basicInfo = angular.copy(basicInfo);
    }

    /* Payment */
    setPayment(payment) {
        Object.assign(this.data, { payment });
    }

    getFormattedPayment() {
        let formattedPayment = angular.copy(this.data.payment);
        if(this.data.payment.method === 'CREDIT' && !this.data.payment.guid) {
            formattedPayment.expiryYear = this.data.payment.expirationDate.substr(2, 3);
            formattedPayment.expiryMonth = this.data.payment.expirationDate.substr(0, 2);
        }
        return formattedPayment;
    }

    /* Checkout */
    finalize() {
        return this._validate()
            .then(() => this._updateCart())
            .then(cart => {
                if (this.cartService.hasWarnings()) {
                    return this.$q.reject();
                }

                return cart;
            })
            .then(() => this._setOrderData());
    }

    _validate() {
        let validators = [];
        validators.push(this.basicInfoService.validate());
        validators.push(this.paymentService.validate());

        if (this.isDelivery()) {
            validators.push(this.addressService.validateWithDeliveryRange());
        }

        return this.$q.all(validators)
            .then(() => this._setValidData());
    }

    _setValidData() {
        this.setBasicInfo(this.basicInfoService.data);
        this.setAddress(this.addressService.data);
        this.setPayment(this.paymentService.data.selectedPayment);
        return this.$q.resolve();
    }

    _updateCart() {
        // With enlightenment, we include the deliveryInfo, tip, and payment with
        // the final placeOrder call so calling this updateCart() is redundant and
        // causes issues with handling out of stock errors.
        return this.cartService.getCart();
    }

    _setOrderData() {
        this._temporaryTransform();
        this.orderInfoService.setCustomerData(this.data.basicInfo);
        this.orderInfoService.setDeliveryInfoData(this.data.address);
        return this.orderInfoService.setPaymentData(this.getFormattedPayment()).then(
            response => response,
            err => {
                this.blockingCalloutService.show(err);
                return this.$q.reject(err);
            }
        );
    }

    //KIT TODO: This is a pretty garbae method, but some places post checkout refer to slightly
    // different keys than this step. This adds those missing keys
    _temporaryTransform(){
        this.data.basicInfo.phone = this.data.basicInfo.phoneNumber;
        this.data.address.streetAddress1 = this.data.address.address1;
        this.data.address.streetAddress2 = this.data.address.address2;
    }

    _getPaymentMethod() {
        const localStoragePayment = this.localStorageService.get(this.LOCAL_STORAGE.PAYMENT);
        return (localStoragePayment && localStoragePayment.method) ? localStoragePayment.method : 'CREDIT';
    }

    isDelivery() {
        return this.cartData.cart && this.cartData.cart.diningOptionBehavior === 'DELIVERY';
    }
}
